import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {CommunicationNode} from '../../../interfaces/CommunicationNodeV2';
import {MapLatLangCoordinates} from '../../common/HazardMap';
import ModalDraggable from '../../common/ModalDraggable';
import AMSSensorItemUpsert from './AMSSensorItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: CommunicationNode;
  mode?: 'view' | 'update' | 'ack';
  prefetch?: boolean;
  locationCoordinates?: MapLatLangCoordinates;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
  onPurged?: () => void;
  onOpenHistory?: (
    id: number | string,
    type: 'amsShortTerm' | 'amsLongTerm' | 'amsLocation'
  ) => void;
  onOpen?: () => void;
  onClose?: Function;
}

const AMSSensorItemUpsertButton = <T extends ComponentType = typeof Button>({
  pk,
  // item,
  mode,
  prefetch,
  locationCoordinates,
  component,
  componentProps,
  children,
  onSubmitted,
  onPurged,
  onOpenHistory,
  onOpen,
  onClose,
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component
        {...componentProps}
        onClick={() => {
          setIsOpened(true);
          onOpen?.();
        }}
      >
        {children}
      </Component>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          {({isActive}) => (
            <AMSSensorItemUpsert
              pk={pk}
              // item={item}
              mode={mode}
              prefetch={prefetch}
              locationCoordinates={locationCoordinates}
              isActiveModal={isActive}
              onClose={() => {
                setIsOpened(false);
                onClose?.();
              }}
              onSubmitted={() => {
                onSubmitted?.();
                if (!pk) {
                  setIsOpened(false);
                  onClose?.();
                }
              }}
              onPurged={onPurged}
              onOpenHistory={onOpenHistory}
            />
          )}
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default AMSSensorItemUpsertButton;
